<!-- 健康体检 -->
<template>
    <div class="app-container">
        <el-container direction="vertical">
            <el-row>
                <el-row>
                    <div style="font-size: 32;font-weight: bolder;">健康体检</div>
                </el-row>
                <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />

            </el-row>

            <el-row style="margin-top: 30px;">
                <el-col style="margin-top: 10px; margin-left: 0px">
                    <el-date-picker v-model="time" @change="dateChange" type="daterange" align="right" unlink-panels
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>

                    <el-button type="primary" style="margin-left: 20px" @click="getList">查询</el-button>
                </el-col>
            </el-row>

            <el-row style="margin-top: 20px;">
                <el-table v-loading="listLoading" :data="list" height="500" border stripe fit highlight-current-row
                    style="margin-top: 8px; margin-left: 0px">
                    <el-table-column align="center" label="体检时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.physicalExamTime }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="体检编号">
                        <template slot-scope="scope">
                            <span>{{ scope.row.physicalExamNum }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="责任医师">
                        <template slot-scope="scope">
                            <span>{{ scope.row.responseDoctorName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button style="margin-left: 0px; align-self: center" type="text"
                                @click="getItemDetail(scope.row)">
                                查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <physicalExaminationDetail v-if="examinationDetailVisible" ref="examinationDetailRef"></physicalExaminationDetail>
                <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum"
                    :limit.sync="listQuery.pageSize" @pagination="getList" />
                

            </el-row>
        </el-container>
    </div>
</template>

<script>
import { getEhrPhysicalExamList } from "@/api/health/Patients";
import physicalExaminationDetail from "./physicalExamination/physicalExaminationDetail.vue"
import moment from "moment";
import pagination from "@/components/Pagination";

export default {
    components: { pagination, physicalExaminationDetail },
    props: {
        pInfo: null,
    },
    data() {
        return {
            examinationDetailVisible:false,
            total: 0,
            listLoading: false,
            list: null,
            listQuery: {
                healthNo: null,
                startTime: null,
                endTime: null,
                pageNum: 1,
                pageSize: 10,
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近半年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一年",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            time: [],
        };
    },
    created() {
        this.listQuery.healthNo = '370284180151036903';//this.pInfo.healthNo;

        if (this.listQuery.startTime == null) {
            this.listQuery.startTime = this.getDate(-365);
            this.listQuery.endTime = this.getDate(1);
        }
        this.time.push(this.listQuery.startTime);
        this.time.push(this.listQuery.endTime);

        this.getList();
    },
    methods: {
        dateChange() {
            this.listQuery.startTime = this.time[0];
            this.listQuery.endTime = this.time[1];
        },
        getList() {
            let data = Object.assign({}, this.listQuery, {
                pageNum: this.listQuery.pageNum - 1
            })
            getEhrPhysicalExamList(data).then((response) => {
                var data = response.data;
                this.list = data.records;
                this.total = data.total;
            });
        },
        getItemDetail(row) {
            this.examinationDetailVisible = true;
            this.$nextTick(() => {
                this.$refs.examinationDetailRef.init(row);
            });
        },
        getDate(day) {
            const now = new Date();
            const monthn = now.getMonth();
            const yearn = now.getFullYear();
            const daten = now.getDate() + day;
            var time = new Date();
            time.setFullYear(yearn, monthn, daten);
            time.setHours(0, 0, 0);

            console.log("time：", time);

            // var formatTime = time.Format("yyyy-MM-ddThh:mm:ss.SZ"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
            var str = moment(time).format("YYYY-MM-DD HH:mm");

            console.log("timeStr：", str);

            return str;
        },
        convertTime(row) {
            // var dt = Date.parse(row);
            // var str = moment(new Date(parseInt(dt))).format("YYYY-MM-DD hh:mm:ss");
            var str = moment(row).format("YYYY-MM-DD HH:mm");
            return str;
        }
    },
};
</script>

<style></style>